import Color from 'color';

export const colorWithoutOpacity = (foregroundWithOpacity: string, backgroundWithoutOpacity: string) => {
	const [f_r, f_g, f_b, a = 1] = Color(foregroundWithOpacity)
		.rgb()
		.array();
	const [b_r, b_g, b_b] = Color(backgroundWithoutOpacity)
		.rgb()
		.array();
	const r = Math.floor(f_r * a + b_r * (1 - a));
	const g = Math.floor(f_g * a + b_g * (1 - a));
	const b = Math.floor(f_b * a + b_b * (1 - a));
	return Color.rgb(r, g, b).hex();
};

export const hexToRgb = (hex: string) => {
	if (!hex) {
		return null;
	}
	hex = hex.replace('#', '');
	if (hex.length === 3) {
		hex = [hex[0], hex[0], hex[1], hex[1], hex[2], hex[2]].join('');
	}
	var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	return result
		? {
				r: parseInt(result[1], 16),
				g: parseInt(result[2], 16),
				b: parseInt(result[3], 16),
		  }
		: null;
};

export const hexToRgbString = (hex: string, opacity: number = 1) => {
	if (!hex) {
		return;
	}
	try {
		const color = Color(hex).alpha(opacity);
		return color.rgb().string();
	} catch {
		return;
	}
};

export const colorWithOpacity = (hex: string, opacity: number) =>
	Color(hex)
		.alpha(opacity)
		.string();

export const colorWithLightness = (hex: string, lightness: number) => {
	const hsl = Color(hex).hsl();
	return `hsl(${hsl.hue()}deg, ${hsl.saturationl()}%, ${hsl.lightness() * lightness}%)`;
};
